import { useMutation } from '@tanstack/react-query';
import { newsletterRepository } from './newsletterRepository';

export function useSubscribe() {
  return useMutation({ mutationFn: (email: string) => newsletterRepository.subscribe(email) });
}

export function useConfirmSubscription() {
  return useMutation({ mutationFn: (token: string) => newsletterRepository.confirm(token) });
}

export function useUnsubscribe() {
  return useMutation({ mutationFn: (token: string) => newsletterRepository.unsubscribe(token) });
}
